import { mapState, mapActions } from 'vuex'
import { formatPrice, formatDate } from '@/helpers'

export default {
  data () {
    return {
      activeItem: 'personal'
    }
  },

  computed: {
    ...mapState({
      loading: ({ people }) => people.loading,
      personData: ({ people }) => people.personData,
      addressData: ({ people }) => people.personData.address,
      paymentData: ({ people }) => people.personData.paymentSlipRegisterAttempt.paymentSlipInfo,
      paymentErrors: ({ people }) => people.personData.paymentSlipRegisterAttempt.errors
    })
  },

  mounted() {
    window.scrollTo(0, 0);
    const { id } = this.$route.params
    this.getPeopleId({id})
  },

  methods: {
    ...mapActions('people', ['getPeopleId']),

    formatedValue (value) {
      if (value) {
        return formatPrice(value)
      }

      return value
    },

    dateFormat (date) {
      if (date) {
        return formatDate(date)
      }

      return date
    },

    documentFormat (document) {
      if (document && document.length === 11) {
        return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
      }

      return document
    },

    zipCodeFormat (zip) {
      if (zip) {
        return zip.replace(/(\d{5})(\d{3})/, "$1-$2")
      }

      return zip
    },

    isActive (menuItem) {
      return this.activeItem === menuItem
    },

    setActive (menuItem) {
      this.activeItem = menuItem
    }
  }
}
